export * from './baScrollPosition.directive';



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/theme/directives/baScrollPosition/index.ts